import React, { useEffect } from 'react';
import SEO from '../components/SEO.jsx';
import Hero from '../components/Hero.jsx';
import EmpathyScrollStory from '../components/EmpathyScrollStory.jsx';
import BreakFree from '../components/BreakFree.jsx';
import Package from '../components/Package.jsx';
import Value from '../components/Value.jsx';
import Experience from '../components/Experience.jsx';
import Testimonials from '../components/Testimonials.jsx';
import SaveTime from '../components/SaveTime.jsx';

/**
 * Home page aggregates all primary sections of the site. It reuses the Hero
 * component for the landing area and then stacks the about, features, value,
 * testimonials and contact sections. Additional pages (Solutions, Blog,
 * Case Studies) are accessible via the navigation bar.
 */
const Home = () => {
  return (
    <main>
      <SEO 
        title="SuiteCRM Implementation & AI CRM Consulting in India | Aakeeo"
        description="Aakeeo Technologies delivers expert CRM consulting, SuiteCRM customization, and AI workflow automation to streamline your operations and boost customer engagement. Transform your business with our cutting-edge solutions."
        keywords={['CRM consulting', 'SuiteCRM', 'AI automation', 'workflow automation', 'business automation', 'CRM implementation', 'customer engagement']}
        og={{
          title: 'Aakeeo Technologies | CRM & AI Automation Experts',
          description: 'Transform your business with expert CRM consulting, SuiteCRM customization, and AI workflow automation. Streamline operations and boost customer engagement.',
          type: 'website'
        }}
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'LocalBusiness',
            'name': 'Aakeeo Technologies',
            'url': 'https://www.aakeeo.com',
            'logo': 'https://www.aakeeo.com/Aakeeo_favicon.png',
            'image': 'https://www.aakeeo.com/Aakeeo_favicon.png',
            'description': 'Bangalore-based SuiteCRM implementation and AI automation consultancy. 10+ years of experience.',
            'telephone': '+91-7795758362',
            'email': 'sales@aakeeo.com',
            'address': {
              '@type': 'PostalAddress',
              'addressLocality': 'Bangalore',
              'addressRegion': 'Karnataka',
              'addressCountry': 'IN'
            },
            'areaServed': 'India',
            'sameAs': [
              'https://twitter.com/aakeeo',
              'https://www.linkedin.com/company/aakeeo'
            ],
            'contactPoint': {
              '@type': 'ContactPoint',
              'telephone': '+91-7795758362',
              'contactType': 'Sales',
              'email': 'sales@aakeeo.com',
              'availableLanguage': ['English', 'Hindi']
            }
          },
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            'name': 'Aakeeo Technologies',
            'url': 'https://www.aakeeo.com',
            'logo': 'https://www.aakeeo.com/Aakeeo_favicon.png',
            'foundingDate': '2015'
          }
        ]}
      />
      <Hero />
      <EmpathyScrollStory />
      <BreakFree />
      <Package />
      <Value />
      <Experience />
      <Testimonials />
      <SaveTime />
    </main>
  );
};

export default Home;